// extracted by mini-css-extract-plugin
export var boxItems = "_b0-1";
export var boxItemsLg = "_b0-2";
export var button = "_b0-7";
export var buttonHoverless = "_b0-9";
export var buttonLg = "_b0-8";
export var filterGroupBox = "_b0-0";
export var icon = "_b0-3";
export var iconSecondary = "_b0-6";
export var iconWrapper = "_b0-4";
export var iconWrapperLg = "_b0-5";
export var truncatedLabel = "_b0-a";